import {ref, reactive, computed, toRefs, nextTick, watchEffect, watch} from 'vue';
import {usePaging} from "@/modules/reader/book/paging";
import {useMuteRoleControl} from "@/modules/reader/karaoke/muteRoleControl";
import {replaceAudioPathForStagingServer} from  "@/modules/utils/pathUtils";

const playBlockState = reactive({
    audioSrcList:null,
    currentSpanIndex:-1,
    activePageNum:null,
    id:null,
    spanSrc:null,
    multiWholePageStatus:{}, //for playmultipageBlock annotation; used for targeting whole page block buttons on each page within the page range (would use it
    multiSpanStatus:{},  //for playSpan:// annotation;  used for playSpan targeting another span (can be same page / different pages)
    multiBlockSpanStatus:{} //for playBlock: // annotation; used for playBlock button that has a span target (can be same page / different pages)
});

let blockPlayer = null;
let spanPlayer = null;

export function usePlayBlockControl() {

    const {muteRoleState} = useMuteRoleControl();

    const setBlockData = (id, pagenum, audioSrcList)=> {
        playBlockState.audioSrcList = audioSrcList;
        playBlockState.activePageNum = pagenum;
        playBlockState.currentSpanIndex = 0;
        playBlockState.id = id;

    }

    const removeBlockData = ()=>{

        if (document.getElementById("blockPlayer")) {
            document.getElementById("blockPlayer").removeEventListener("canplay",onBlockAudioCanPlay);
            document.getElementById("blockPlayer").removeEventListener("ended", playNext);
            document.getElementById("blockPlayer").removeEventListener("timeupdate", setAudioMuteState);
        }

        playBlockState.audioSrcList = null;
        playBlockState.currentSpanIndex = -1;
        playBlockState.id = null;
        playBlockState.multiWholePageStatus = {};
        playBlockState.multiBlockSpanStatus = {};

    }


    const playBlocks = ()=> {
        //next tick is required since the blockplayer <audio> element is available only when currentSpanIndex = 0.
        //After the element is ready, the listener will work:
        nextTick(()=> {
            document.getElementById("blockPlayer").addEventListener("ended", playNext);
            document.getElementById("blockPlayer").addEventListener("timeupdate", setAudioMuteState);
        });
    }

    const playSpan = (spanSrc, pagenum)=> {

        removeBlockData();

        //if served on staging (.23), update url to make 206 response available...
        spanSrc = replaceAudioPathForStagingServer(spanSrc);
        playBlockState.spanSrc = spanSrc;
        playBlockState.activePageNum = pagenum;
        nextTick(()=> {
            let spanPlayer = document.getElementById("spanPlayer");
            spanPlayer.pause();
            spanPlayer.muted = false
            spanPlayer.addEventListener("canplay", onSpanCanPlay);
        });

    }

    /**
     * Require canplay event listener, otherwise, a very short time of audio will play and cannot be muted on iPad
     */
    const onSpanCanPlay = ()=>{
        let spanPlayer = document.getElementById("spanPlayer");
        spanPlayer.removeEventListener("canplay", onSpanCanPlay);
        spanPlayer.addEventListener("ended", onSpanAudioEnded);
        spanPlayer.addEventListener("timeupdate", setAudioMuteState);
        spanPlayer.muted = true;
        spanPlayer.play();
    }


    const setAudioMuteState = (e)=>{
        //console.log("@timeupdate!!!@spanplayer")
        //console.log(" muteRoleState.isMuted;: " +  muteRoleState.isMuted)
        e.target.muted = muteRoleState.isMuted;
    };

    /**
     * Determine whether end a single span or play the next span on the target page if multiple span is detected.
     */
    const onSpanAudioEnded = (e)=>{

        document.getElementById("spanPlayer").removeEventListener("ended", onSpanAudioEnded);
        document.getElementById("spanPlayer").removeEventListener("timeupdate", setAudioMuteState);

        //if there is multi span targets:
        if (playBlockState.multiSpanStatus.btnIdPageMapping) {

            let playedCount;
            let currentTargetPageNum = playBlockState.multiSpanStatus.aimPageIndex;
            playBlockState.multiSpanStatus.playedCount++;
            playedCount= playBlockState.multiSpanStatus.playedCount;

            //if not all target spans have completed:
            if (playedCount < playBlockState.multiSpanStatus.btnIdPageMapping.length) {
                //playedCount now will point to the next aimPage data
                playBlockState.multiSpanStatus.aimPageBtnId = playBlockState.multiSpanStatus.btnIdPageMapping[playedCount].aimPageBtnId;
                playBlockState.multiSpanStatus.aimPageIndex = playBlockState.multiSpanStatus.btnIdPageMapping[playedCount].aimPageIndex;

                //if the next button id page number is different from the current page,
                //or if the first span page number is different from the first button of the mapping list (in this case, only the direct target span has played),
                //then a page turn should be performed:
                if (currentTargetPageNum !== playBlockState.multiSpanStatus.btnIdPageMapping[playedCount].aimPageIndex ||
                    (playedCount === 0 && playBlockState.multiSpanStatus.firstSpanPageNum !== playBlockState.multiSpanStatus.btnIdPageMapping[playedCount].aimPageIndex)
                ) {
                    playBlockState.multiSpanStatus.isTargeted = true;
                    usePaging().setCurrentPage(playBlockState.multiSpanStatus.aimPageIndex, true);
                }
            //otherwise, all target spans should have completed and remove data to stop the cycle.
            } else {
                removeSpanData();
            }
        //otherwise, it should be simple single span, just remove data to complete.
        } else {
            removeSpanData();
        }

    }

    const removeSpanData = ()=> {
        if (document.getElementById("spanPlayer")) {
            document.getElementById("spanPlayer").removeEventListener("ended", onSpanAudioEnded);
            document.getElementById("spanPlayer").removeEventListener("timeupdate", setAudioMuteState);
            document.getElementById("spanPlayer").removeEventListener("canplay", onSpanCanPlay);
        }

        playBlockState.spanSrc = null;
        playBlockState.activeRole = null;
        playBlockState.currentSpanIndex = -1;
        playBlockState.activePageNum = null;
        playBlockState.multiSpanStatus = {};

    }

    /**
     * Require canplay event listener, otherwise, a very short time of audio will play and cannot be muted on iPad
     */
    const onBlockAudioCanPlay = ()=>{
        document.getElementById("blockPlayer").muted = true;

       // setTimeout(()=>{
        document.getElementById("blockPlayer").addEventListener("ended", playNext);
        document.getElementById("blockPlayer").addEventListener("timeupdate", setAudioMuteState);
        document.getElementById("blockPlayer").play();
        //}, 300)
    }
    /**
     * Play the next audio in play block mode.
     * Will be looped executing until all audios have completed playing
     */
    const playNext = ()=>{

        //Important : must remove timeupdate listener and set unmute, otherwise, there will be problem in muting audio in iOS safari!
        document.getElementById("blockPlayer").removeEventListener("canplay",onBlockAudioCanPlay);
        document.getElementById("blockPlayer").removeEventListener("ended", playNext);
        document.getElementById("blockPlayer").removeEventListener("timeupdate", setAudioMuteState);
        document.getElementById("blockPlayer").muted = false;

        playBlockState.currentSpanIndex++;

        document.getElementById("blockPlayer").pause();
        document.getElementById("blockPlayer").addEventListener("canplay", onBlockAudioCanPlay);


        //if current span index equals to audio src list item count, the all audios of the current page should have finished:
        if (playBlockState.currentSpanIndex === playBlockState.audioSrcList.length) {

            //if there is multiPageTargetBtnId data in multiWholePageStatus, it should be multi whole page mode, determine whether all pages have done:
            if (playBlockState.multiWholePageStatus.multiPageTargetBtnId) {

                playBlockState.multiWholePageStatus.playedPageCount++;

                //if not all pages have played, assign the next target button and page number:
                if (playBlockState.multiWholePageStatus.playedPageCount < playBlockState.multiWholePageStatus.btnIdPageMapping.length) {
                    playBlockState.multiWholePageStatus.multiPageTargetBtnId = playBlockState.multiWholePageStatus.btnIdPageMapping[playBlockState.multiWholePageStatus.playedPageCount]["aimPageBtnId"]
                    playBlockState.multiWholePageStatus.multiPageTargetPageNum = playBlockState.multiWholePageStatus.btnIdPageMapping[playBlockState.multiWholePageStatus.playedPageCount]["aimPageIndex"]
                    playBlockState.currentSpanIndex = -1;

                    document.getElementById("blockPlayer").removeEventListener("canplay",onBlockAudioCanPlay);
                    document.getElementById("blockPlayer").removeEventListener("ended", playNext);
                    document.getElementById("blockPlayer").removeEventListener("timeupdate", setAudioMuteState);

                    //perform a page turn:
                    nextTick(() => {
                        usePaging().setCurrentPage(playBlockState.multiWholePageStatus.multiPageTargetPageNum, true);
                    });
                    //otherwise, all audios of all the pages have finished playing and remove data to compete the cycle:
                } else {
                    removeBlockData();
                }

                //if there is aimPageBtnId data in multiBlockSpanStatus, it should now be a playBlock button that targets another span or playBlock button.
                //Since the target should play once only and won't further target other buttons, a isTargeted boolean can be used (simply by toggling) to determine
                //whether the target has played or not. If not then play the target:
            } else if (playBlockState.multiBlockSpanStatus.aimPageBtnId && !playBlockState.multiBlockSpanStatus.isTargeted) {

                playBlockState.multiBlockSpanStatus.isTargeted = true;

                //if the page number of the target button is different from the current page, perform a page turn
                if (playBlockState.multiBlockSpanStatus.aimPageIndex !== playBlockState.multiBlockSpanStatus.activePagenum) {

                    //nextTick(() => {
                        usePaging().setCurrentPage(playBlockState.multiBlockSpanStatus.aimPageIndex, true);
                    //});
                }
                //otherwise, it should be simple playBlock button playNext cycle, just reset everything to complete:
            } else {
                reset();
            }
        }


    }

    const reset = ()=>{
        removeSpanData();
        removeBlockData();
    }

    return {
        playBlockState,
        playBlocks,
        playSpan,
        setBlockData,
        removeBlockData,
        removeSpanData,
        reset
    }
}